// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "__federation_expose_DynamicChildViewWidget" + "." + "abf37030" + ".chunk.css";
};